import { SearchIcon } from '@/components/icons';
import { useFormStatus } from 'react-dom';

export default function SearchButton() {
  const { pending } = useFormStatus();

  return (
    <button
      type="submit"
      className="w-10 h-10 flex shrink-0 items-center justify-center bg-primary-500 rounded-full cursor-pointer hover:bg-primary-400 active:bg-primary-500"
    >
      {pending ?
        <div
          className="animate-spin rounded-full border-2 border-[#111615] border-t-transparent"
          style={{ width: 24, height: 24 }}
        />
        : <SearchIcon />}
    </button>
  );
}
